export default __webpack_public_path__ + "static/media/clashing-logo-without-text.e4cf65a4.svg";